export function useFacebook() {
  const config = useRuntimeConfig()

  tryOnMounted(() => {
    // If FB is already defined, initialize it
    if (typeof window.FB !== 'undefined') {
      console.log('FB already exists, initializing...')
      window.FB.init({
        appId: config.public.facebookAppId,
        xfbml: true,
        version: 'v22.0',
      })
      console.log('Facebook SDK initialized')
      return
    }

    // Otherwise, set up the async init
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: config.public.facebookAppId,
        xfbml: true,
        version: 'v22.0',
      })
    }
  })
}
